/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';

import { Button, Stack } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { createCompareDraft } from '../../axiosClient/draftApi';
import CustomModal from '../../components/CustomModal';
import RISelectComponent from '../../components/SelectComponent';
import { RootState, useTypedSelector } from '../../redux/store';

interface IProps {
  open: boolean;
  handleClose: VoidFunction;
}

const SelectCompareDraft: React.FC<IProps> = ({ open, handleClose }) => {
  const { connectedDrafts } = useTypedSelector(
    (state: RootState) => state.draft
  );
  const navigate = useNavigate();

  const methods = useForm();

  const { control, handleSubmit } = methods;

  const { mutate: createCompareMutation } = useMutation({
    mutationKey: ['create-compare-draft'],
    mutationFn: createCompareDraft,
    onSuccess: (response: any) => {
      navigate(`/compare/drafts/${response.id}`);
    },
  });

  const onSubmit = useCallback((data: any) => {
    createCompareMutation(data);
  }, []);

  return (
    <CustomModal
      title="Compare two Draft"
      open={open}
      maxWidth="md"
      handleClose={handleClose}
    >
      <FormProvider {...methods}>
        <Stack
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          mt={2}
          spacing={2}
          sx={{ width: '500px', padding: '30px 10px' }}
        >
          <RISelectComponent
            control={control}
            name="original_draft"
            required
            options={connectedDrafts}
            label="Original Draft"
          />
          <RISelectComponent
            control={control}
            name="compare_draft"
            required
            options={connectedDrafts}
            label="Revised Draft"
          />
          <Button variant="contained" type="submit">
            Compare Draft
          </Button>
        </Stack>
      </FormProvider>
    </CustomModal>
  );
};

export default SelectCompareDraft;
